module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( isMe ) { 
__p+=' <h4 class="icon icon-labelled icon-material icon-user">'+
((__t=( i18n.tc("UserSettings", "My account") ))==null?'':__t)+
'</h4> ';
 } else { 
__p+=' <h4 class="icon icon-labelled icon-material icon-user">'+
((__t=( i18n.tc("UserSettings", "User panel") ))==null?'':__t)+
'</h4> ';
 } 
__p+=' ';
 if ( showUserRoles ) { 
__p+=' ';
 if ( ! active ) { 
__p+=' <div><span class="label">'+
((__t=( i18n.tc( "UserSettings", "Active:" ) ))==null?'':__t)+
'</span><p class="static error" data-text="user-inactive">'+
((__t=( i18n.tc( "UserSettings", "This user account is not active!" ) ))==null?'':__t)+
'</p></div> ';
 } 
__p+=' <fieldset><dl><dt class="label">'+
((__t=( i18n.tc("EditCustomer", "User access:") ))==null?'':__t)+
'</dt><dd class="input">'+
((__t=( userRoles ))==null?'':__t)+
'</dd></dl></fieldset> ';
 } 
__p+=' <div><h5>'+
((__t=( i18n.tc( "UserSettings", "Contact information" ) ))==null?'':__t)+
'</h5><nav class="module-menu"><ul><li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-email">'+
((__t=( i18n.tc( "UserSettings", "Email" ) ))==null?'':__t)+
'</a></li><li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-phone-numbers">'+
((__t=( i18n.tc( "UserSettings", "Phone numbers" ) ))==null?'':__t)+
'</a></li></ul></nav></div><div><h5>'+
((__t=( i18n.tc( "UserSettings", "Account settings" ) ))==null?'':__t)+
'</h5><nav class="module-menu"><ul><li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-language">'+
((__t=( i18n.tc( "UserSettings", "Language" ) ))==null?'':__t)+
'</a></li><li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-password">'+
((__t=( i18n.tc( "UserSettings", "Password" ) ))==null?'':__t)+
'</a></li><li><a class="snippet has-ripple ripple-primary" href="#" data-click="nav-billing">'+
((__t=( i18n.tc( "UserSettings", "Billing accounts" ) ))==null?'':__t)+
'</a></li></ul></nav></div>';
}
return __p;
};
